// @ts-nocheck
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductDeliveryTerms, { ProductDeliveryTermsStyles } from "@store/Library/Components/ProductDeliveryTerms";
import React, { FC } from "react";

const enum fields {
    termsAndConditionsLink = "termsAndConditionsLink",
    overrideLinkLabel = "overrideLinkLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.termsAndConditionsLink]: LinkFieldValue;
        [fields.overrideLinkLabel]: string;
    };
}

type Props = OwnProps & WidgetProps;

export const productDetailsDeliveryTermsStyles: ProductDeliveryTermsStyles = {};

const styles = productDetailsDeliveryTermsStyles;

const ProductDetailsDeliveryTerms: FC<Props> = ({ id, fields: { termsAndConditionsLink, overrideLinkLabel } }) => {
    return (
        <ProductDeliveryTerms
            id={id}
            extendedStyles={styles}
            termsAndConditionsLink={termsAndConditionsLink}
            overrideLinkLabel={overrideLinkLabel}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsDeliveryTerms,
    definition: {
        group: "Product Details",
        displayName: "Product Details Delivery Terms",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.termsAndConditionsLink,
                displayName: "Delivery Terms T&C Link",
                editorTemplate: "LinkField",
                fieldType: "General",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
            },
            {
                name: fields.overrideLinkLabel,
                displayName: "Override T&C Link Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
